export const TableSkeleton = ({ columnCount = 0, rowCount = 6 }) => {
  return (
    <>
      {[...Array(rowCount)].map((_, rowIndex) => (
        <tr key={rowIndex}>
          <td>
            <div className="placeholder-glow">
              <span className="placeholder col-4 rounded-2"></span>
            </div>
          </td>

          {[...Array(columnCount)].map((_, colIndex) => (
            <td key={colIndex}>
              <div className="placeholder-glow">
                <span className="placeholder col-8 rounded-2"></span>
              </div>
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

